import React, { useEffect, useState } from "react";
import { useHistory } from "react-router";
import { getAllMasterServicesDetails, getWondersoftDrugs, syncDrugs } from "core/services/api";
import Table from "../../../../components/Table";
import { WONDERSOFT_COLUMNS } from "./WondersoftColumn";
import Button from "../../../../components/Button";
import Toast from "../../../../components/Toast";


function Wondersoft() {
  const history = useHistory()
  const [allWondersoftDrugs, setAllWondersoftDrugs] = React.useState([])
  const [services, setServices] = useState<any>([])
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [displayToast, toggleToast] = useState<any>()
  const [syncDrugsLoading, setSyncDrugsLoading] = useState<boolean>(false)


  useEffect(() => {
    getAdminServices()
  }, [])

  useEffect(() => {
    setIsLoading(true)
    if (services && services.length > 0) {
      getWondersoftDrug()
    }
  }, [services])

  function getAdminServices() {
    const query = `services`
    getAllMasterServicesDetails(query)
      .then((res) => {
        setServices(res)
      })
      .catch((err) => {
        console.log("err", err)
      })
  }

  const getWondersoftDrug = () => {
    getWondersoftDrugs()
      .then((res) => {
        console.log("res", res)
        const filtered = (res || []).map((drug: any) => {
          const mappedServices = (drug?.services || []).map((serviceId: string) => {
            const svc = services?.find((s: any) => s?.id === serviceId);
            return svc ? svc.name : serviceId;
          });

          return {
            id: drug?.id,
            dpco: drug?.dpco,
            brandName: drug?.brandName,
            genericName: drug?.genericName,
            drugType: drug?.drugType,
            highRisk: drug?.highRisk,
            sideEffects: drug?.sideEffects || [],
            services: mappedServices,
          };
        });

        setAllWondersoftDrugs(filtered);
        setIsLoading(false)
      })
      .catch((err) => {
        setIsLoading(false)
        console.log("err", err)
        toggleToast({
          type: "error",
          text: err?.response?.data?.message
            || "Something went wrong",
        })
      })
  }


  const handleSyncDrugs = () => {
    setSyncDrugsLoading(true);
    syncDrugs()
      .then((res) => {
        setSyncDrugsLoading(false)
        toggleToast({
          type: "success",
          text: res,
        })
        getWondersoftDrug()
      })
      .catch((err) => {
        setSyncDrugsLoading(false)
        toggleToast({
          type: "error",
          text: err?.response?.data?.message
            ? err?.response?.data?.message
            : "Something went wrong while syncing drugs",
        })
      })

  }

  if (isLoading) {
    return <div className="automatic-id-generation-wrapper">
      <div className="heading">
        <div
          className="back-image"
          onClick={() => {
            history.push("/home")
          }}
        >
          <img
            src={"../../../assets/images/back-icon.svg"}
            height={"60px"}
            width={"60px"}
            alt="back button"
          />
        </div>
        <div className="header-text">Wondersoft Drug</div>
      </div>
      <div
        style={{
          position: "absolute",
          top: "50%",
          right: "50%",
        }}
      >
        <div
          style={{ width: "3rem", height: "3rem" }}
          className="spinner-border text-primary"
        ></div>
      </div>
    </div>
  }


  return (
    <div className="automatic-id-generation-wrapper">
      {displayToast && (
        <Toast
          textMessage={displayToast?.text}
          onClose={() => {

            toggleToast(false)
          }}
          onCloseText={"Close"}
          type={displayToast?.type}
        />
      )}

      <div className="heading">
        <div
          className="back-image"
          onClick={() => {
            history.push("/home")
          }}
        >
          <img
            src={"../../../assets/images/back-icon.svg"}
            height={"60px"}
            width={"60px"}
            alt="back button"
          />
        </div>
        <div className="header-text">Wondersoft Drug</div>
      </div>
      <div className="button-alignment">
        <div>
          <Button
            text="Sync Drugs"
            type="submit"
            disabled={syncDrugsLoading}
            onClick={() => handleSyncDrugs()}
            id="cancel"
          />
        </div>
      </div>

      <div className="manage-centers-container">
        <div>
          <Table
            data={allWondersoftDrugs}
            columns={WONDERSOFT_COLUMNS}
            globalFilterRequired={true}
            onRowClick={(id: any) => { }}
            onColClick={(colValue: any, id: any) => {
              history.push(`/wondersoft-drug/${id}`);
            }}
          />
        </div>
      </div>
    </div>
  )

}
export default Wondersoft;
